import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { History as HistoryIcon, ChevronRight } from "lucide-react";
import { api, apiError } from "../api";
import { PageLoader, EmptyState, StatusBadge, Toast, useToast } from "../components/ui";

function fmt(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("en-GB", { timeZone: "Indian/Mauritius", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
}

export default function History() {
  const navigate = useNavigate();
  const { toast, show, close } = useToast();
  const [scans, setScans] = useState(null);

  useEffect(() => {
    api.get("/scans").then((r) => setScans(r.data.scans)).catch((e) => { show(apiError(e), "error"); setScans([]); });
  }, []);

  if (scans === null) return <PageLoader label="Loading history" />;

  return (
    <div className="fade-in">
      <Toast toast={toast} onClose={close} />
      <h1 className="font-display text-2xl md:text-3xl text-ink mb-1">Scan history</h1>
      <p className="text-sm text-muted mb-6">Runs from the last 30 days.</p>

      {scans.length === 0 ? (
        <EmptyState icon={HistoryIcon} title="No scans yet" description="Run a scan from a profile to see results here." testId="history-empty" />
      ) : (
        <div className="space-y-3" data-testid="history-list">
          {(scans || []).map((s) => (
            <button key={s.id} onClick={() => navigate(`/scans/${s.id}`)} className="card p-4 w-full text-left" data-testid={`history-row-${s.id}`}>
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <div className="font-medium text-ink truncate">{s.profile_name}</div>
                  <div className="text-sm text-muted mt-0.5">Target {s.target_date} · {s.trigger}</div>
                </div>
                <StatusBadge status={s.status} />
              </div>
              <div className="flex items-center justify-between mt-3 text-sm">
                <div className="flex gap-4 text-muted">
                  <span>{s.matched_count} matched</span>
                  <span className="text-ink font-medium">{s.changes_count} changes</span>
                </div>
                <div className="flex items-center gap-1 text-muted">
                  {fmt(s.started_at || s.created_at)} <ChevronRight className="w-4 h-4" />
                </div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
